export const getConfluencePageSearchURL = ({
	cqlQuery,
	cloudId,
	gatewayBaseUrl = '',
}: {
	cqlQuery: string;
	cloudId: string;
	gatewayBaseUrl: string;
}) =>
	`${gatewayBaseUrl}/gateway/api/ex/confluence/${cloudId}/wiki/rest/api/content/search?${new URLSearchParams(
		{
			cql: cqlQuery,
			expand: 'space.typeSettings,link',
		},
	).toString()}`;
